import { WEB_COMPONENT_GENERIC_DASHBOARD_RESET_VIEW } from '../../../webcomponents.constants';
import { html, LitElement } from 'lit';
import { store } from '../../../redux/store';
import { connect } from 'pwa-helpers';
import { styles } from '../view/styles';
import { ButtonColors, ButtonFontSizes, ButtonHeights, ButtonTypes } from '../../../ui/gzButton/types';
import { translateFn } from '../../../utils/translator.helper';
import { resetFilters } from '../../redux/dashboard.filters.slice';
import { resetWidgets } from '../../redux/dashboards.widgets.slice';
import { customElement } from 'lit/decorators.js';

@customElement(WEB_COMPONENT_GENERIC_DASHBOARD_RESET_VIEW)
export class GzDashboardResetViewWebComponent extends connect(store)(LitElement) {
  constructor() {
    super();
  }

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="generic-dashboard-reset-view">
        <gz-button
          id="reset-view-button"
          type="${ButtonTypes.QUIET}"
          color="${ButtonColors.SECONDARY}"
          buttonHeight="${ButtonHeights.SMALL}"
          buttonFontSize="${ButtonFontSizes.SMALL}"
          @click="${this.resetViewButtonClicked}"
          lowercase
          >${translateFn('Reset View')}
        </gz-button>
      </div>
    `;
  }

  private resetViewButtonClicked() {
    store.dispatch(resetFilters());
    store.dispatch(resetWidgets());
  }
}
